import React, { Component } from 'react'
import Pitch from '../components/Pitch/Pitch'
import Pitch3D from '../components/Pitch/Pitch3D'
import TextControl from '../components/TextControl'
import SoundComponent from '../components/Sound/SoundComponent'
import Header from '../components/HeaderComponent'
import MoveToMinuteControl from '../components/MoveToMinuteControl'
import StatsWindowContainer from '../components/PopupStats/StatsWindowContainer'
import { loadGameJSON, loadLocalJSON, MOVE_TO_NEXT_EVENT, MOVE_TO_START } from '../actions/gameActions'
import { startGame, pauseGame, requestReplay, move_to_minute, move_to_next_episod, move_to_prev_episod }from '../actions/UserActions'
import * as GameViewMode from '../constants/GameViewMode'
import { connect } from 'react-redux'
import StartingLineupWindow from './Info/StartingLineupWindow'
import InfoContainer from './Info/InfoContainer'
import '../index.css';
import '../modal.css';
import '../progressbar.css';

class MainComponent extends Component {

    constructor(props) {
        super(props);
        this.handleClick = this.handleClick.bind(this);

        this.pitchWidth = 0;
        this.pitchHeight = 0;
        this.pitchIdent = 0;
        this.LoadingMessage = "Loading..."

        this.Settings = window.TextSettings;

        if(this.props.params.urlString != null){
            this.props.dispatch(loadGameJSON(this.props.params.urlString));
            return;
        }

        if(process.env.NODE_ENV == "development") {

            if(this.props.params.source != null){
                this.props.dispatch(loadLocalJSON(this.props.params.source));
                return;
            }
    

            this.props.dispatch(loadLocalJSON('game_full.json'));
        }

        if(process.env.NODE_ENV == "production") {
            this.LoadingMessage = "Ошибка загрузки матча";
        }
    }

    componentDidMount() {
        if(this.props.GameLoaded) {
            this.calculateHtmlPositions();
            this.forceUpdate();
        }

        window.onresize = (event) => {
            if(this.props.GameLoaded) {
                this.calculateHtmlPositions();
                this.forceUpdate();
            }
        };

        this.attachKeyDown();
    }

    attachKeyDown() {
        document.addEventListener("keydown", (e)=> {
            var keyCode = e.keyCode;
            if(keyCode==32) { //пробел
                if(this.props.Paused)
                    this.props.dispatch(startGame());
                else
                    this.props.dispatch(pauseGame());
                e.preventDefault()
            }
            else if(keyCode==82) { //R
                this.props.dispatch(requestReplay());
            }
            else if(keyCode==37 || keyCode==39) { //left and right
                
                if(window.gameViewMode == GameViewMode.Full) {
                    let event = window.Json.game[this.props.CurrentEvent-1];
                    let currentMinute  = this.props.CurrentEvent == 0 ? 0 : event.minute;
    
                    if(keyCode==37) {
                        if(currentMinute > 1)
                            this.props.dispatch(move_to_minute(currentMinute-1));
                    }
                    else {
                        var last = window.Json.game[window.Json.game.length - 1];
                        if(currentMinute < last.minute)
                            this.props.dispatch(move_to_minute(currentMinute+1));
                    }
                }
                else {
                    if(keyCode===39) {
                        this.props.dispatch(move_to_next_episod());
                    }
                    if(keyCode===37) {
                        this.props.dispatch(move_to_prev_episod());
                    }
                }

                e.preventDefault();
            }
        }, false);
    }

    componentDidUpdate(prevProps, prevState){
        if(this.props.GameLoaded != prevProps.GameLoaded) {
            this.calculateHtmlPositions();
            this.forceUpdate();
        }
    }

    calculateHtmlPositions() {
        let el = document.getElementById("field-col");
        let style = el.currentStyle || window.getComputedStyle(el);
        let padding = parseFloat(style.paddingLeft) + parseFloat(style.paddingRight)
        this.pitchWidth = (el.offsetWidth - padding)*0.8;
        this.pitchIdent = this.pitchWidth * 50.0 / 970.0;
        this.pitchHeight = (this.pitchWidth - 2*this.pitchIdent) * 450 / 720 + 2*this.pitchIdent;
    }

    handleClick(event){
       this.props.dispatch(MOVE_TO_NEXT_EVENT());
    }

    render() {
      if(this.props.GameLoaded == false)
        return (<div>{this.LoadingMessage}</div>)

      return (<div className="container">
                <Header />
                <div id="bottom-controls">
                    <MoveToMinuteControl />
                    {this.Settings.ShowText &&
                        <TextControl />
                    }
                </div>
                <div className="row" id="central-field">
                    <div className="col-md-12" id="field-col">
                        {this.props.PitchWindowMode == false ? <Pitch windowMode={false} width={this.pitchWidth} height={this.pitchHeight} ident={this.pitchIdent} weather={parseInt(this.props.weather)} halfTime={0} /> : null}
                    </div>
                </div>

                {this.props.Show3d ? <Pitch3D width={this.pitchWidth} height={this.pitchHeight} /> : null}
                <SoundComponent />
                <div id="footer">
                  <StatsWindowContainer/>
                  <StartingLineupWindow />
                  {
                    process.env.NODE_ENV == "development" &&
                        <div>
                            <input type="button" onClick={this.handleClick} value="Move Next"/>
                            <input type="button" onClick={() => this.props.dispatch(MOVE_TO_START())} value="Move on start"/>
                            <div>Event: {this.props.CurrentEvent}</div>
                            <InfoContainer currentEvent={this.props.CurrentEvent} />
                        </div>
                  }
                </div>
				<div id="warning-message"><div className="warning-message-image"></div><div className="warning-message-text"></div></div>
				<div className="modal-backdrop fade in"></div>
              </div>)
    }
}

function mapStateToProps(state, ownProps) {
    return {
        GameLoaded: state.jsonLoaded,
        Speed: state.gameSpeed,
        Paused: state.paused,
        Show3d: state.show3d,
        weather: state.weather,
        CurrentEvent: state.currentEvent,
        PitchWindowMode: state.statisticWindows.pitch.visible
    };
}

export default connect(mapStateToProps)(MainComponent)



/** WEBPACK FOOTER **
 ** ./src/components/MainComponent.js
 **/